import { Main } from "./main";
import "styles/header.css";

export const LikedVideos = () => {
  return (
    <>
      <Main />
    </>
  );
};
